var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.012,
    height: 35,
    viewBox: "0 0 43.012 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-twitter",
    "data-name": "Icon ionic-logo-twitter",
    d: "M44.425,8.647a17.84,17.84,0,0,1-5.068,1.395A8.855,8.855,0,0,0,43.24,5.156,17.534,17.534,0,0,1,37.635,7.3a8.822,8.822,0,0,0-15.267,6.034,8.639,8.639,0,0,0,.228,2.014A25.008,25.008,0,0,1,4.4,6.113,8.842,8.842,0,0,0,7.146,17.908a8.619,8.619,0,0,1-4.01-1.1v.109a8.832,8.832,0,0,0,7.082,8.659,8.883,8.883,0,0,1-2.324.31,8.325,8.325,0,0,1-1.659-.164,8.838,8.838,0,0,0,8.249,6.134A17.692,17.692,0,0,1,3.519,35.635a17.887,17.887,0,0,1-2.105-.128A24.666,24.666,0,0,0,14.921,39.5c16.251,0,25.129-13.462,25.129-25.138,0-.383-.009-.766-.027-1.139A17.963,17.963,0,0,0,44.425,8.647Z",
    transform: "translate(-1.413 -4.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4de33c0d.svg";
export { ForwardRef as ReactComponent };